<template>
    <md-menu md-direction="bottom-end" md-align-trigger md-close-on-click>
        <md-button class="md-just-icon md-primary" md-menu-trigger>
            <md-icon> more_horiz</md-icon>
        </md-button>
        <md-menu-content>
            <li>
                <a @click="actionEditt">Edit</a>
            </li>
            <li>
                <a @click="actionRestore">Restore</a>
            </li>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        name: "UserDeletedMoreDropdown",
        props: {
            user: {
                type: Object,
                required: true,
            }
        },
        methods: {
            actionEditt() {
                let path = this.$enums.RoutePathEnum.USER_UPDATE;
                path = path.replace(':id', this.user.id);

                this.$router.push(path);
            },
            actionRestore() {
                let id = this.user.id;
                this.$api.restoreUser({
                    segments: {
                        userId: id,
                    },
                }).then(() => {
                    this.$bus.emit('updateIndex')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>